// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import "./List.css";
// import { formatDate, formatDateTime } from "../../../../utils/fn";
// import { NavLink } from "react-router-dom";

// // --- DYNAMIC PERMISSION LOGIC ---
// const usePermissions = () => {
//   const authData = useMemo(() => {
//     try {
//       const userDetailsString = localStorage.getItem("zTaskUserDetails");
//       if (!userDetailsString) return { user: null, permissions: [] };
//       const userDetails = JSON.parse(userDetailsString);
//       const permissions = userDetails?.role?.permissions
//         ? userDetails.role.permissions.map((p) => p.title)
//         : [];
//       return { user: userDetails, permissions };
//     } catch (error) {
//       console.error("Failed to parse user details from localStorage:", error);
//       return { user: null, permissions: [] };
//     }
//   }, []);

//   const hasPermission = useCallback(
//     (requiredPermission) => {
//       if (Array.isArray(requiredPermission)) {
//         return requiredPermission.some((p) => authData.permissions.includes(p));
//       }
//       return authData.permissions.includes(requiredPermission);
//     },
//     [authData]
//   );

//   return { user: authData.user, hasPermission };
// };
// // --- END PERMISSION LOGIC ---

// const WorkOrderList = () => {
//   const [workOrders, setWorkOrders] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const { user, hasPermission } = usePermissions();

//   useEffect(() => {
//     if (!user) {
//       setIsLoading(false);
//       setError("User details not found. Please log in again.");
//       return;
//     }

//     const fetchAllData = async () => {
//       setIsLoading(true);
//       try {
//         const token = localStorage.getItem("zTaskAuthToken");
//         const headers = {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         };

//         const workOrdersUrl = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/work-order/api/work-orders`;
//         const customersUrl = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/customer/api/customers/`;
//         const projectsUrl = `${process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL}/api/get-project`;
//         const usersUrl = `${process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL}/api/get-users`;

//         const [
//           workOrdersResponse,
//           customersResponse,
//           projectsResponse,
//           usersResponse,
//         ] = await Promise.all([
//           fetch(workOrdersUrl, { headers }),
//           fetch(customersUrl, { headers }),
//           fetch(projectsUrl, { headers }),
//           fetch(usersUrl, { headers }),
//         ]);

//         if (!workOrdersResponse.ok)
//           throw new Error("Failed to fetch work orders.");
//         if (!customersResponse.ok)
//           throw new Error("Failed to fetch customers.");
//         if (!projectsResponse.ok) throw new Error("Failed to fetch projects.");
//         if (!usersResponse.ok) throw new Error("Failed to fetch users.");

//         const workOrdersData = await workOrdersResponse.json();
//         const customersData = await customersResponse.json();
//         const projectsData = await projectsResponse.json();
//         const usersData = await usersResponse.json();

//         if (hasPermission("VIEW ALL WORK ORDERS")) {
//           setWorkOrders(workOrdersData);
//         } else {
//           const userWorkOrders = workOrdersData.filter(
//             (wo) => wo.added_by === user.id
//           );
//           setWorkOrders(userWorkOrders);
//         }

//         setCustomers(customersData);
//         setProjects(projectsData.projects || []);
//         setUsers(usersData.userData || []);
//       } catch (err) {
//         setError(err.message);
//         console.error("Error fetching data:", err);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchAllData();
//   }, [user, hasPermission]);

//   const customerMap = useMemo(
//     () =>
//       customers.reduce((map, customer) => {
//         map[customer.id] = customer.name;
//         return map;
//       }, {}),
//     [customers]
//   );

//   const projectMap = useMemo(
//     () =>
//       projects.reduce((map, project) => {
//         map[project.projectId] = project.projectName;
//         return map;
//       }, {}),
//     [projects]
//   );

//   const userMap = useMemo(
//     () =>
//       users.reduce((map, u) => {
//         map[u.id] = u.name;
//         return map;
//       }, {}),
//     [users]
//   );

//   // Filter work orders based on search term
//   const filteredWorkOrders = useMemo(() => {
//     if (!searchTerm.trim()) {
//       return workOrders;
//     }

//     const searchLower = searchTerm.toLowerCase();

//     return workOrders.filter((wo) => {
//       const customerName = customerMap[wo.cust_id]?.toLowerCase() || "";
//       const projectName = projectMap[wo.project_id]?.toLowerCase() || "";
//       const createdByName = userMap[wo.added_by]?.toLowerCase() || "";
//       const updatedByName = userMap[wo.updated_by]?.toLowerCase() || "";

//       return (
//         wo.id?.toString().includes(searchLower) ||
//         wo.wo_no?.toLowerCase().includes(searchLower) ||
//         wo.doc_no?.toLowerCase().includes(searchLower) ||
//         customerName.includes(searchLower) ||
//         wo.cust_id?.toString().includes(searchLower) ||
//         projectName.includes(searchLower) ||
//         wo.project_id?.toString().includes(searchLower) ||
//         wo.tot_value?.toString().includes(searchLower) ||
//         wo.wo_open_close?.toLowerCase().includes(searchLower) ||
//         createdByName.includes(searchLower) ||
//         wo.added_by?.toString().includes(searchLower) ||
//         updatedByName.includes(searchLower) ||
//         wo.updated_by?.toString().includes(searchLower) ||
//         formatDate(wo.wo_date)?.toLowerCase().includes(searchLower) ||
//         formatDateTime(wo.add_date)?.toLowerCase().includes(searchLower) ||
//         formatDateTime(wo.update_date)?.toLowerCase().includes(searchLower) ||
//         wo.kind_attn?.toLowerCase().includes(searchLower) ||
//         wo.amendment_no?.toLowerCase().includes(searchLower)
//       );
//     });
//   }, [workOrders, searchTerm, customerMap, projectMap, userMap]);

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleClearSearch = () => {
//     setSearchTerm("");
//   };

//   // Helper function to check if user can edit a specific work order
//   const canEditWorkOrder = useCallback(
//     (workOrder) => {
//       // Check if user has "EDIT ALL WORK ORDERS" permission
//       if (hasPermission("EDIT ALL WORK ORDERS")) {
//         return true;
//       }
//       // Check if user is the creator of the work order
//       if (user?.id === workOrder.added_by) {
//         return true;
//       }
//       return false;
//     },
//     [user, hasPermission]
//   );

//   if (isLoading) {
//     return <div className="loading-message">Loading work orders...</div>;
//   }

//   if (error) {
//     return <div className="error-message">Error: {error}</div>;
//   }

//   return (
//     <div className="work-order-list-container">
//       {/* Search Bar */}
//       <div className="search-bar-container">
//         <div className="search-input-wrapper">
//           <input
//             type="text"
//             className="search-input"
//             placeholder="Search by WO No, Customer, Project, Status, ID, or any field..."
//             value={searchTerm}
//             onChange={handleSearchChange}
//           />
//           {searchTerm && (
//             <button className="clear-search-btn" onClick={handleClearSearch}>
//               ✕
//             </button>
//           )}
//         </div>
//         <div className="search-results-info">
//           {searchTerm && (
//             <span>
//               Found {filteredWorkOrders.length} of {workOrders.length} work orders
//             </span>
//           )}
//         </div>
//       </div>

//       {filteredWorkOrders.length === 0 ? (
//         <p className="no-data-message">
//           {searchTerm
//             ? `No work orders found matching "${searchTerm}"`
//             : "No work orders found."}
//         </p>
//       ) : (
//         <div className="work-order-table-wrapper">
//           <table>
//             <thead>
//               <tr>
//                 <th>ID</th>
//                 <th>WO No.</th>
//                 <th>WO Date</th>
//                 <th>Customer Name</th>
//                 <th>Customer ID</th>
//                 <th>Project Name</th>
//                 <th>Project ID</th>
//                 <th>Total Value</th>
//                 <th>Status</th>
//                 <th>Created By Name</th>
//                 <th>Created By ID</th>
//                 <th>Created Date</th>
//                 <th>Updated By Name</th>
//                 <th>Updated By ID</th>
//                 <th>Updated Date</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredWorkOrders.map((wo) => {
//                 const canEdit = canEditWorkOrder(wo);
                
//                 return (
//                   <tr key={wo.id}>
//                     <td>{wo.id}</td>
//                     <td>{wo.wo_no}</td>
//                     <td>{formatDate(wo.wo_date)}</td>
//                     <td>{customerMap[wo.cust_id] || "N/A"}</td>
//                     <td>{wo.cust_id}</td>
//                     <td>{projectMap[wo.project_id] || "N/A"}</td>
//                     <td>{wo.project_id}</td>
//                     <td>
//                       ₹
//                       {wo.tot_value
//                         ? parseFloat(wo.tot_value).toLocaleString("en-IN", {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2,
//                           })
//                         : "0.00"}
//                     </td>
//                     <td>{wo.wo_open_close}</td>
//                     <td>{userMap[wo.added_by] || "N/A"}</td>
//                     <td>{wo.added_by}</td>
//                     <td>{formatDateTime(wo.add_date)}</td>
//                     <td>
//                       {wo.updated_by ? userMap[wo.updated_by] || "N/A" : "N/A"}
//                     </td>
//                     <td>{wo.updated_by || "N/A"}</td>
//                     <td>{formatDateTime(wo.update_date)}</td>
//                     <td className="actions-cell">
//                       {hasPermission("SET WORK ORDER") && (
//                         <NavLink
//                           to={`/work-orders/${wo.id}/edit`}
//                           style={{
//                             pointerEvents: canEdit ? "auto" : "none",
//                           }}
//                           onClick={(e) => {
//                             if (!canEdit) e.preventDefault();
//                           }}
//                         >
//                           <button
//                             className="edit-button"
//                             disabled={!canEdit}
//                           >
//                             Edit
//                           </button>
//                         </NavLink>
//                       )}
//                       {hasPermission([
//                         "VIEW WORK ORDER",
//                         "VIEW ALL WORK ORDERS",
//                       ]) && (
//                         <NavLink to={`/work-orders/${wo.id}`}>
//                           <button className="view-button">View</button>
//                         </NavLink>
//                       )}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default WorkOrderList;




import React, { useState, useEffect, useMemo, useCallback } from "react";
import "./List.css";
import { formatDate, formatDateTime } from "../../../../utils/fn";
import { NavLink } from "react-router-dom";
import { IoCreateOutline, IoEyeOutline } from "react-icons/io5";
import { getNodeServiceBaseUrl, getSwaggerServiceBaseUrl } from "../../../../config/apiBase";
import { EmptyState } from "../../../../shared-ui/States";

// --- DYNAMIC PERMISSION LOGIC ---
const usePermissions = () => {
  const authData = useMemo(() => {
    try {
      const userDetailsString = localStorage.getItem("zTaskUserDetails");
      if (!userDetailsString) return { user: null, permissions: [] };
      const userDetails = JSON.parse(userDetailsString);
      const permissions = userDetails?.role?.permissions
        ? userDetails.role.permissions.map((p) => p.title)
        : [];
      return { user: userDetails, permissions };
    } catch (error) {
      console.error("Failed to parse user details from localStorage:", error);
      return { user: null, permissions: [] };
    }
  }, []);

  const hasPermission = useCallback(
    (requiredPermission) => {
      if (Array.isArray(requiredPermission)) {
        return requiredPermission.some((p) => authData.permissions.includes(p));
      }
      return authData.permissions.includes(requiredPermission);
    },
    [authData]
  );

  return { user: authData.user, hasPermission };
};
// --- END PERMISSION LOGIC ---

const WorkOrderList = () => {
  const [workOrders, setWorkOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { user, hasPermission } = usePermissions();

  useEffect(() => {
    if (!user) {
      setIsLoading(false);
      setError("User details not found. Please log in again.");
      return;
    }

    const fetchAllData = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("zTaskAuthToken");
        const headers = {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        };

        const workOrdersUrl = `${getNodeServiceBaseUrl()}/work-order/api/work-orders`;
        const customersUrl = `${getNodeServiceBaseUrl()}/customer/api/customers/`;
        const projectsUrl = `${getSwaggerServiceBaseUrl()}/api/get-project`;
        const usersUrl = `${getSwaggerServiceBaseUrl()}/api/get-users`;

        const [
          workOrdersResponse,
          customersResponse,
          projectsResponse,
          usersResponse,
        ] = await Promise.all([
          fetch(workOrdersUrl, { headers }),
          fetch(customersUrl, { headers }),
          fetch(projectsUrl, { headers }),
          fetch(usersUrl, { headers }),
        ]);

        if (!workOrdersResponse.ok)
          throw new Error("Failed to fetch work orders.");
        if (!customersResponse.ok)
          throw new Error("Failed to fetch customers.");
        // Projects are enrichment only — do not block the WO list if Java denies/fails
        if (!projectsResponse.ok) {
          console.warn("Failed to fetch projects.", projectsResponse.status);
        }
        if (!usersResponse.ok) {
          console.warn("Failed to fetch users.", usersResponse.status);
        }

        const workOrdersData = await workOrdersResponse.json();
        const customersData = await customersResponse.json();
        const projectsData = projectsResponse.ok
          ? await projectsResponse.json()
          : { projects: [] };
        const usersData = usersResponse.ok
          ? await usersResponse.json()
          : { userData: [] };

        if (hasPermission("VIEW ALL WORK ORDERS")) {
          setWorkOrders(
            [...workOrdersData].sort((a, b) => Number(b.id) - Number(a.id))
          );
        } else {
          const userWorkOrders = workOrdersData.filter(
            (wo) => wo.added_by === user.id
          );
          setWorkOrders(
            [...userWorkOrders].sort((a, b) => Number(b.id) - Number(a.id))
          );
        }

        setCustomers(customersData);
        setProjects(projectsData.projects || []);
        setUsers(usersData.userData || []);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllData();
  }, [user, hasPermission]);

  const customerMap = useMemo(
    () =>
      customers.reduce((map, customer) => {
        map[customer.id] = customer.name;
        return map;
      }, {}),
    [customers]
  );

  const projectMap = useMemo(
    () =>
      projects.reduce((map, project) => {
        map[project.projectId] = project.projectName;
        return map;
      }, {}),
    [projects]
  );

  const userMap = useMemo(
    () =>
      users.reduce((map, u) => {
        map[u.id] = u.name;
        return map;
      }, {}),
    [users]
  );

  // Filter work orders based on search term
  const filteredWorkOrders = useMemo(() => {
    if (!searchTerm.trim()) {
      return workOrders;
    }

    const searchLower = searchTerm.toLowerCase();

    return workOrders.filter((wo) => {
      const customerName = customerMap[wo.cust_id]?.toLowerCase() || "";
      const projectName = projectMap[wo.project_id]?.toLowerCase() || "";
      const createdByName = userMap[wo.added_by]?.toLowerCase() || "";
      const updatedByName = userMap[wo.updated_by]?.toLowerCase() || "";

      return (
        wo.id?.toString().includes(searchLower) ||
        wo.wo_no?.toLowerCase().includes(searchLower) ||
        wo.doc_no?.toLowerCase().includes(searchLower) ||
        customerName.includes(searchLower) ||
        wo.cust_id?.toString().includes(searchLower) ||
        projectName.includes(searchLower) ||
        wo.project_id?.toString().includes(searchLower) ||
        wo.tot_value?.toString().includes(searchLower) ||
        wo.wo_open_close?.toLowerCase().includes(searchLower) ||
        createdByName.includes(searchLower) ||
        wo.added_by?.toString().includes(searchLower) ||
        updatedByName.includes(searchLower) ||
        wo.updated_by?.toString().includes(searchLower) ||
        formatDate(wo.wo_date)?.toLowerCase().includes(searchLower) ||
        formatDate(wo.add_date)?.toLowerCase().includes(searchLower) ||
        formatDate(wo.update_date)?.toLowerCase().includes(searchLower) ||
        wo.kind_attn?.toLowerCase().includes(searchLower) ||
        wo.amendment_no?.toLowerCase().includes(searchLower)
      );
    });
  }, [workOrders, searchTerm, customerMap, projectMap, userMap]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  // Helper function to check if user can edit a specific work order
  const canEditWorkOrder = useCallback(
    (workOrder) => {
      // Check if user has "EDIT ALL WORK ORDERS" permission
      if (hasPermission("EDIT ALL WORK ORDERS")) {
        return true;
      }
      // Check if user is the creator of the work order
      if (user?.id === workOrder.added_by) {
        return true;
      }
      return false;
    },
    [user, hasPermission]
  );

  if (isLoading) {
    return <div className="loading-message">Loading work orders...</div>;
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  return (
    <div className="work-order-list-container">
      {/* Search Bar */}
      <div className="search-bar-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder="Search by WO No, Customer, Project, Status, ID, or any field..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {searchTerm && (
            <button className="clear-search-btn" onClick={handleClearSearch}>
              ✕
            </button>
          )}
        </div>
        <div className="search-results-info">
          {searchTerm && (
            <span>
              Found {filteredWorkOrders.length} of {workOrders.length} work orders
            </span>
          )}
        </div>
      </div>

      {filteredWorkOrders.length === 0 ? (
        <EmptyState
          title="No work orders"
          description={
            searchTerm
              ? `No work orders found matching "${searchTerm}"`
              : "Work orders will appear here once they are created."
          }
        />
      ) : (
        <div className="work-order-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>WO No.</th>
                <th>WO Date</th>
                <th>Customer Name</th>
                <th>Customer ID</th>
                <th>Project Name</th>
                <th>Project ID</th>
                <th>Total Value</th>
                <th>Status</th>
                <th>Created By Name</th>
                <th>Created By ID</th>
                <th>Created Date</th>
                <th>Updated By Name</th>
                <th>Updated By ID</th>
                <th>Updated Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredWorkOrders.map((wo) => {
                const canEdit = canEditWorkOrder(wo);
                
                return (
                  <tr key={wo.id}>
                    <td>{wo.id}</td>
                    <td>{wo.wo_no}</td>
                    <td>{formatDate(wo.wo_date)}</td>
                    <td>{customerMap[wo.cust_id] || "N/A"}</td>
                    <td>{wo.cust_id}</td>
                    <td>{projectMap[wo.project_id] || "N/A"}</td>
                    <td>{wo.project_id}</td>
                    <td>
                      ₹
                      {wo.tot_value
                        ? parseFloat(wo.tot_value).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "0.00"}
                    </td>
                    <td>{wo.wo_open_close}</td>
                    <td>{userMap[wo.added_by] || "N/A"}</td>
                    <td>{wo.added_by}</td>
                    <td>{formatDate(wo.add_date)}</td>
                    <td>
                      {wo.updated_by ? userMap[wo.updated_by] || "N/A" : "N/A"}
                    </td>
                    <td>{wo.updated_by || "N/A"}</td>
                    <td>{formatDate(wo.update_date)}</td>
                    <td className="actions-cell">
                      {hasPermission("SET WORK ORDER") && (
                        <NavLink
                          to={`/work-orders/${wo.id}/edit`}
                          style={{
                            pointerEvents: canEdit ? "auto" : "none",
                          }}
                          onClick={(e) => {
                            if (!canEdit) e.preventDefault();
                          }}
                          title="Edit"
                        >
                          <button
                            type="button"
                            className="icon-btn icon-btn-edit"
                            disabled={!canEdit}
                            aria-label="Edit"
                          >
                            <IoCreateOutline size={18} />
                          </button>
                        </NavLink>
                      )}
                      {hasPermission([
                        "VIEW WORK ORDER",
                        "VIEW ALL WORK ORDERS",
                      ]) && (
                        <NavLink to={`/work-orders/${wo.id}`} title="View">
                          <button
                            type="button"
                            className="icon-btn icon-btn-view"
                            aria-label="View"
                          >
                            <IoEyeOutline size={18} />
                          </button>
                        </NavLink>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WorkOrderList;